<section class="container padding-top-10 padding-bottom-10 relatorio-list">
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <div class='page-header'>
        <div class='btn-toolbar pull-right'>
          <div class='btn-group'>
            <div class="btn btn-primary btn-sm btn-action" ng-click="relatorio.new()" title="Novo Relatório de visita">
              Novo <i class="fa fa-plus"></i>
            </div>
          </div>
        </div>
        <h2>Relatório de visitas</h2>
      </div>
    </div>
  </div>

  <p ng-show="relatorio.itens && !relatorio.itens.length">
    Nenhum relatório gerado ainda.
  </p>

  <uib-alert ng-show="relatorio.url" type="info">
    <a ng-href="{{relatorio.url}}" target="_blank">
      Relatório gerado com sucesso! <strong>Clique aqui para baixar</strong>
    </a>
  </uib-alert>

  <button class="btn btn-success btn-sm" title="Gera todos os relatórios selecionados em um só arquivo" ng-click="relatorio.gerarVarios()">
    <span ng-if="relatorio.gerando"><i class="fa fa-spinner fa-spin"></i></span>
    <span ng-if="!relatorio.gerando"><i class="fa fa-file-text-o"></i></span>
    Gerar selecionados
  </button>

  <table class="table table-hover" ng-show="relatorio.itens.length">
    <thead>
      <tr>
        <th>
          <label>
            <input type="checkbox" ng-model="relatorio.allSelected" ng-click="relatorio.toggleSelections()">
          </label>
        </th>
        <th>#</th>
        <th>Data do Relatório</th>
        <th>Usuário</th>
        <th>Criado em</th>
        <th></th>
      </tr>
    </thead>

    <tbody>
      <tr ng-repeat="item in relatorio.itens track by item.id">
        <td>
          <label>
            <input type="checkbox" ng-model="relatorio.selectedReports[$index]" ng-true-value="{{::item.id}}" ng-false-value="{{undefined}}">
          </label>
        </td>
        <td>{{::item.id}}</td>
        <td>{{::item.data | date:'dd/MM/yyyy'}}</td>
        <td>{{::item.usuario.nome_completo | capitalize}}</td>
        <td>{{::item.created_at | date:'dd/MM/yyyy HH:mm'}}</td>
        <td class="text-right actions-buttons">
          <button class="btn btn-danger btn-sm" title="Excluir" ng-click="relatorio.remove(item)">
            <i class="glyphicon glyphicon-trash"></i>
          </button>

          <a class="btn btn-primary btn-sm" title="Visualizar/Editar" ng-href="#!/relatoriovisitacustomizado/{{::item.id}}">
            <i class="glyphicon glyphicon-eye-open"></i>
          </a>

          <a ng-show="item.htmlLink" target="_blank" class="btn btn-primary btn-sm" title="Compartilhar" ng-href="{{::item.htmlLink}}">
            <i class="glyphicon glyphicon-share"></i>
          </a>
          <a ng-show="item.htmlLink" class="btn btn-primary btn-sm" title="Copiar link"
            ng-click="relatorio.copiarLink(item.htmlLink)">
            <i class="glyphicon glyphicon-copy"></i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</section>
